import React from 'react'
import { Testimonial } from './Testimonial'
import { TitleHighlight } from '../../../ui/typo/TitleHighlight'
import { HomeHeading } from '../Heading'
import { useIsVisible } from '../../../../Utils/useIsVisible'

export const TestimonialsSection = () => {
  const testimonials = [
    {
      content: `Cela m’a permis d’avoir une page du site internet où on est plus "sexy". Maintenant, je réponds à tous les candidats en 2 clics, et ils me répondent en retour. J'ai fait déjà plusieurs recrutements via le site. Je recommande +++`,
      avatar: '/profile-edwige-jacob.webp',
      fullName: 'Edwige Jacob',
      role: 'Experte-Comptable Associée',
      company: 'Ephisens',
      youtubeUrl: 'https://www.youtube.com/watch?v=5cm7nOKDgTk',
    },
    {
      content: `On a déjà recruté 3 profils en 6 mois. Ce qui est vraiment top par rapport à ce qui se fait traditionnellement avec les cabinets de recrutement.`,
      avatar: '/profile-thomas-palmieri.webp',
      fullName: 'Thomas Palmieri',
      role: 'Expert-Comptable Associé',
      company: 'Stratt',
      youtubeUrl: 'https://www.youtube.com/watch?v=TSASUbPWy2k',
    },
    {
      content: `On a fait 4 recrutements d'alternants et 2 CDI, on en est pleinement satisfaits. Moi depuis que j'utilise Lamacompta, je ne sollicite plus du tout les cabinets de recrutement.`,
      avatar: '/profile-vincent-beguin.webp',
      fullName: 'Vincent Beguin',
      role: 'Expert-Comptable Associé',
      company: 'Wired',
      youtubeUrl: 'https://www.youtube.com/watch?v=y-SmEsEVRlQ',
    },
  ]
  const ref = React.createRef<HTMLDivElement>()
  const isRefVisible = useIsVisible(ref)

  return (
    <div
      ref={ref}
      className={`transition-all duration-100 md:duration-500 ${isRefVisible ? 'motion-preset-expand' : 'opacity-0'
        }`} // https://rombo.co/tailwind/
    >
      <section className="container px-4 py-12 mx-auto space-y-8 md:py-14 lg:py-20 xl:py-24 md:space-y-10 lg:space-y-12 xl:space-y-14">
        <div className="space-y-4 md:w-1/2 md:space-y-8">
          <HomeHeading additionalClasses="text-center md:text-left">
            Ils participent à <TitleHighlight>lamaventure</TitleHighlight>
          </HomeHeading>

          <p className="text-lg font-medium text-center text-night md:text-left">
            Notre communauté est notre meilleure ambassadrice. Les cabinets et
            candidats qui rejoignent Lamacompta partagent notre vision et nos
            valeurs.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 md:gap-8 md:grid-cols-3">
          {testimonials.map((testimonial) => (
            <Testimonial testimonial={testimonial} key={testimonial.fullName} />
          ))}
        </div>
      </section>
    </div>
  )
}
